import request from "@/utils/request";

export function notificationSettingsGet(params) {
    return request({
        url: "/api/services/app/Notification/GetNotificationSettings",
        method: "GET",
        params
    });
}

export function formNotificationSettingsGet(params) {
    return request({
        url: "/api/services/app/Notification/GetFormNotificationSettings",
        method: "GET",
        params
    });
}

export function subjectTypeNotificationSettingsGet(params) {
    return request({
        url: "/api/services/app/Notification/GetSubjectTypeNotificationSettings",
        method: "GET",
        params
    });
}

export function inventoryTypeNotificationSettingsGet(params) {
    return request({
        url: "/api/services/app/Notification/GetInventoryTypeNotificationSettings",
        method: "GET",
        params
    });
}

export function formNotificationSettingsUpdate(data) {
    return request({
        url: "/api/services/app/Notification/UpdateFormNotificationSettings",
        method: "PUT",
        data
    });
}

export function userNotificationsGet(params) {
    return request({
        url: "/api/services/app/Notification/GetUserNotifications",
        method: "GET",
        params
    });
}

export function notificationSetAllAsRead(data) {
    return request({
        url: "/api/services/app/Notification/SetAllNotificationsAsRead",
        method: "POST",
        data
    });
}

export function notificationSettingsUpdate(data) {
    return request({
        url: "/api/services/app/Notification/UpdateNotificationSettings",
        method: "PUT",
        data
    });
}

export function subjectTypeNotificationSettingsUpdate(data) {
    return request({
        url: "/api/services/app/Notification/UpdateSubjectTypeNotificationSettings",
        method: "PUT",
        data
    });
}

export function inventoryTypeNotificationSettingsUpdate(data) {
    return request({
        url: "/api/services/app/Notification/UpdateInventoryTypeNotificationSettings",
        method: "PUT",
        data
    });
}

export function notificationSetAsRead(data) {
    return request({
        url: "/api/services/app/Notification/SetNotificationAsRead",
        method: "POST",
        data
    });
}

export function notificationSendTest(data) {
    return request({
        url: "/api/services/app/Notification/SendTestNotification",
        method: "POST",
        data
    });
}

export function notificationBroadcast(data) {
    return request({
        url: "/api/services/app/Notification/BroadcastNotification",
        method: "POST",
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/notification.js